import { render, staticRenderFns } from "./MDate.vue?vue&type=template&id=eb5dec2a&scoped=true"
import script from "./MDate.vue?vue&type=script&lang=js"
export * from "./MDate.vue?vue&type=script&lang=js"
import style0 from "./MDate.vue?vue&type=style&index=0&id=eb5dec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5dec2a",
  null
  
)

export default component.exports